//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectEdgeList.js";
import "../no/SelectPointList.js";
import "../Drawings/Drawings.SelectDraftingViewList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CreatedOrdinateOrigin",1,"TaggedObject",0],[1,"HoleTable",0,"SelectEdgeList",0],[1,"OrdinateOrigin",0,"SelectPointList",0],[0,"QuadrantType",1,0],[0,"SelectionType",1,0],[1,"TableAddHole",0,"SelectEdgeList",0],[1,"TableHole",0,"SelectEdgeList",0],[0,"TableOrigin",1,"Point",0],[1,"TableView",0,"Drawings.SelectDraftingViewList",0],[0,"Type",1,0]],[[["quadrant","viewTag","pointData"],"CreateOrdinateOrigin",{R_:{ordinateTag:"TaggedObject"}},3,0]],[]];
SPLM.Tooling.HoleReportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.HoleReportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.HoleReportBuilder.Types = Object.freeze({
    "CreateTable" : "CreateTable", "UpdateTable" : "UpdateTable"});

SPLM.Tooling.HoleReportBuilder.EnumSelectionType = Object.freeze({
    "ViewSelection" : "ViewSelection", "WindowSelection" : "WindowSelection"});

SPLM.Tooling.HoleReportBuilder.EnumQuadrantType = Object.freeze({
    "PositiveQuadrantI" : "PositiveQuadrantI", "PositiveQuadrantIi" : "PositiveQuadrantIi", "PositiveQuadrantIii" : "PositiveQuadrantIii", "PositiveQuadrantIv" : "PositiveQuadrantIv", "PositiveQuadrantAll" : "PositiveQuadrantAll"});

export default SPLM;